// extracted by mini-css-extract-plugin
module.exports = {"title":"SwitchNetwork_title__QcR96","text":"SwitchNetwork_text___oAzn","info":"SwitchNetwork_info__u8xHu","btns":"SwitchNetwork_btns__3Udvq","button":"SwitchNetwork_button__1W7ER"};